import useMediaQuery from '@mui/material/useMediaQuery';
import { Theme, useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { styled } from '@mui/material/styles';
import { pathOr, toLower } from 'ramda';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import HeaderAuthButton from 'src/components/Buttons/HeaderAuthButton';
import ProductTile from 'src/components/Card/ProductTile';
import Footer from 'src/components/Layouts/Footer';
import { LogoImage } from 'src/components/Layouts/Layout.styles';
import { mutateProduct } from 'src/features/Advisors/Applications/SummaryMortgage/commonContext';
import { RESIDENTIAL_MORTGAGE } from 'src/features/LoansHome/Products/constants';
import SiteSettings from 'src/siteSetting';
import { svgLogoUrl, svgAuthPicUrl } from 'src/utilities/logo';
import { isNotEmpty, returnIsNotEmptyOrTrue } from 'src/utilities/hasValue';
import { getQueryParam } from 'src/utilities/queryParams';
import { useRouteMatch } from 'react-router-dom';
import { PASSWORDLESS_ROUTE, START_NEW_APPLICATION_ROUTE } from 'src/route_constants';
import { unAuthenticatedUser } from 'src/utilities/storage';
import UserManageLoader from '../Login/UserManageLoader';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import parse from 'html-react-parser';
import { doNothing } from 'src/services/constants';
import { useSessionHook } from 'src/hooks/useSessionHook';
import { useDispatch } from 'react-redux';
import { clearUserPreSpecificIntent } from 'src/store/siteConfigurator/userSpecificIntent/userSpecificIntent.requests';
import FDICBanner from 'src/components/Layouts/FDICBanner';

interface Props {
    title: any;
    products?: any;
    advisorSubProducts?: any;
    loanType?: string;
}
const BackgroundContainer = styled(Grid)(({ theme }) => ({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.primaryColor,
}));

const Header = styled('header')(({ theme }) => ({
    width: '100%',
    zIndex: 1000,
    top: 0,
    backgroundColor: theme.palette.mainLight,
}));

const HeaderContainer = styled(Box)(({ theme }) => ({
    width: '100%',
    display: 'flex',
    height: '70px',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: '20px!important',
    paddingRight: '32px!important',
    borderBottom: `1px solid ${theme.palette.borderColor}`,
    [theme.breakpoints.down('sm')]: {
        height: 60,
    },
}));

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        imageText: {
            position: 'absolute',
            top: 116,
            left: 93,
            zIndex: 1,
            color: theme.palette.mainLight,
            maxWidth: 400,
            fontSize: '35px',
            lineHeight: '50px',
        },
        imageSubText: {
            position: 'absolute',
            top: 175,
            left: 93,
            zIndex: 1,
            fontSize: 16,
            color: theme.palette.mainLight,
            maxWidth: 460,
            lineHeight: '22px',
        },
        logo: {
            maxHeight: '60%',
            maxWidth: '95%',
        }
    })
);





const ProductContainer = (props: Props) => {
    const { title, products = [], advisorSubProducts, loanType } = props;
    const isStartNewApplication = useRouteMatch(`${START_NEW_APPLICATION_ROUTE}`);
    const subProducts = advisorSubProducts || mutateProduct(products, RESIDENTIAL_MORTGAGE, false);
    const history = useHistory();
    const dispatch = useDispatch()

    const { advisorUsername: advisorNameFromSession } = useSessionHook()
    const getStartedProductTitle = SiteSettings.generalGetStartedProductTitle();
    const advisorUsername = pathOr(null, ['location', 'state', 'advisorUsername'], history) || getQueryParam(location.search, 'advisor') || advisorNameFromSession

    useEffect(() => {
        returnIsNotEmptyOrTrue(isNotEmpty(advisorUsername), unAuthenticatedUser.advisorUsername.set(advisorUsername), doNothing)
    }, [])


    const clearWorkflow = () => {
        dispatch(clearUserPreSpecificIntent())
        return unAuthenticatedUser.workFlowIntent.set({});
    }

    const handleSelect = (product: any) => {
        const aliasName = pathOr('', ['aliasname'], product)
        const subProduct = pathOr('', ['value'], product);
        clearWorkflow()
        unAuthenticatedUser.productType.set(subProduct);
        unAuthenticatedUser.aliasName.set(aliasName);
        const manageLoginTime = new UserManageLoader();
        // settingup loggedin time immediately after the signup
        manageLoginTime.setLoggedInTime()
        const redirectUrl = isStartNewApplication ? '/loans' : isNotEmpty(advisorUsername) ? `${PASSWORDLESS_ROUTE}/${toLower(aliasName)}-${toLower(subProduct)}?advisor=${advisorUsername}`
            : `${PASSWORDLESS_ROUTE}/${aliasName}-${toLower(subProduct)}`
        history.push(redirectUrl)
    }
    const { breakpoints } = useTheme();
    const matchesLg = useMediaQuery(breakpoints.down('lg'));
    const classes = useStyles();

    return (
        <Box>
            <Box
                sx={{
                    height: 'calc(100vh - 40px)'
                }}
            >
                <Grid container sx={{
                    height: 'calc(100vh - 40px)'
                }}>
                    <Grid
                        item
                        md={6}
                        sm={12}
                        sx={{
                            background:
                                'linear-gradient(180deg, rgba(251, 250, 255, 0.5) 0%, rgba(255, 255, 255, 0) 71.99%)',
                        }}
                        position="relative"
                    >
                        {!isStartNewApplication &&
                            <Box>
                                <FDICBanner/>
                                <Header>
                                    <HeaderContainer>
                                        <LogoImage src={svgLogoUrl()} alt="" />
                                        <HeaderAuthButton />
                                    </HeaderContainer>
                                </Header>
                            </Box>}

                        <ProductTile
                            title={title}
                            options={subProducts}
                            onHandleSelect={handleSelect}
                            showCardHorizonal={true}
                            loanType={loanType}
                        />
                    </Grid>
                    <BackgroundContainer
                        md={6}
                        sx={{
                            [breakpoints.down('md')]: {
                                display: 'none',
                            },
                            height: '100%'
                        }}
                        item
                        pt={6.75}
                    >
                        {isNotEmpty(getStartedProductTitle) && !matchesLg &&
                            <Typography
                                component="h1"
                                variant="h1"
                                className={classes.imageText}
                            >
                                Welcome!
                            </Typography>}

                        {isNotEmpty(getStartedProductTitle) && !matchesLg &&
                            <Typography
                                className={classes.imageSubText}
                                variant="body2"
                            >
                                {parse(getStartedProductTitle)}
                            </Typography>}
                        <img src={svgAuthPicUrl()} alt="logo" className={classes.logo} />
                    </BackgroundContainer>
                </Grid>
                <Box>
                    <Footer hasBorderTop />
                </Box>
            </Box>
        </Box>
    );
};

export default ProductContainer;
